import { render } from "./FoodSafetyHistory.vue?vue&type=template&id=4669ec8a&scoped=true"
import script from "./FoodSafetyHistory.vue?vue&type=script&lang=js"
export * from "./FoodSafetyHistory.vue?vue&type=script&lang=js"

import "./FoodSafetyHistory.vue?vue&type=style&index=0&id=4669ec8a&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4669ec8a"]])

export default __exports__